import { Customization } from 'services/api/entities/events/types/internal/event-models'
import { yupObject, YupSchema, yupString } from 'services/yup'

export const customizationVS: YupSchema<Customization> = yupObject().shape({
  name: yupString().optional(), // to be made mandatory when all customizations become arrays of customizations
  description: yupString().optional(),
})
